
import { Component, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { AuthService } from '../../core/services/auth.service';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { Dialog } from '@angular/cdk/dialog';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { MatDialog } from '@angular/material/dialog';
import { SessionStorageService } from '../../core/services/session-storage.service';
import { references } from '../../core/services/references.service';

@Component({
    selector: 'app-login',
    imports: [
    MatCardModule,
    MatFormFieldModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    MatSnackBarModule,
    MatProgressSpinnerModule
],
    templateUrl: './login.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './login.component.scss'
})
export class LoginComponent {
  #fb = inject(FormBuilder);
  #authService = inject(AuthService);
  #snackBar = inject(MatSnackBar);
  #router = inject(Router);
  #dialogRef = inject(MatDialog);
  #storage = inject(SessionStorageService);

  public hide = signal<boolean>(true);
  public loading = signal<boolean>(false);
  public currentYear = signal<Number | null>(null);

  public form = this.#fb.group({
    user: [null, [Validators.required]],
    password: [null, Validators.required],
  });

  ngOnInit(): void {
    this.currentYear.set(new Date().getFullYear());
  }

  forgotPassword() {
    const dialogRef = this.#dialogRef.open(ForgotPasswordComponent, {
      autoFocus: false,
      minWidth: '350px',
      panelClass: 'custom-dialog-container',
      disableClose: false,
      data: '',
    });

    dialogRef.afterClosed().subscribe((x) => {
      if (x) {
      }
    });
  }

  onSubmit(): void {
    this.loading.set(true);

    const formResult = this.form.value;
    const body: any = {
      username: formResult.user,
      password: formResult.password,
    };

    this.#authService.onRequestLogin(body).subscribe({
      next: (resp) => {
        const decodedToken = this.#storage.decodeToken(resp.access_token);
        const requiredRole = references._USER_ROLE;
        const userRoles = decodedToken.role;

        if (!userRoles.includes(requiredRole)) {
          this.#snackBar.open('Usuário não autorizado.', 'fechar', {
            horizontalPosition: 'right',
            verticalPosition: 'top',
            duration: 5000,
          });
          return;
        }

        this.#authService.token$.next(resp.access_token);
        this.#storage.save(references._STORAGE_TOKEN, resp.access_token);

        this.#authService.user$.next(body.username);
        this.#storage.save(references._STORAGE_USER, body.username);

        this.#router.navigate(['/home']);
      },
      error: (e) => {
        this.loading.set(false);
        this.#snackBar.open(
          'Problemas ao realizar o login. Verifique o Usuário e senha!',
          'fechar',
          {
            horizontalPosition: 'right',
            verticalPosition: 'top',
            duration: 5000,
          },
        );
      },
      complete: () => this.loading.set(false),
    });
  }
}
